import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { MyContext } from "../../Context/MyProvider";


const Organizer = () => {

    const { BaseUrl } = useContext(MyContext);

    const { t } = useTranslation();
    const [selectButton, setSelectButton] = useState("Today");
    const [data, setData] = useState([]);

    const Navigate = useNavigate();

    const Location = useLocation();
    const Sponserid = Location.state;

    useEffect(() => {
        window.scrollTo(0, 0);
        
        axios.post(`${BaseUrl}user_api/event_status_wise.php`, { orag_id: Sponserid, status: selectButton })
            .then((res) => {
                setData(res.data.order_data);
            })
            .catch((error) => {
                console.error("event_status_wise", error);
            })

    }, [selectButton]);

    const HandleNavigate = (item) => {
        Navigate("/event-details", { state: selectButton });
        sessionStorage.setItem("Eventid", item);
    }

    return (
        <div className="width_container">
            <div className="">
                <div className="flex justify-center rounded-[20px] mb-[30px] mt-[20px]">
                    <div className="bg-white inline-block rounded-[50px] px-[10px] py-[10px]">
                        <div className="flex items-center gap-[20px]">
                            <button onClick={() => setSelectButton("Today")} className={`${selectButton === "Today" && "booking-active"} booking-button`}>{t("Today")}</button>
                            <button onClick={() => setSelectButton("Upcoming")} className={`${selectButton === "Upcoming" && "booking-active"} booking-button`}>{t("Upcoming")}</button>
                            <button onClick={() => setSelectButton("Past")} className={`${selectButton === "Past" && "booking-active"} booking-button`}>{t("Past")}</button>
                        </div>
                    </div>
                </div>

                <div className="booking">
                    {data.length >= 1
                        ? data.map((item, index) => {
                            return <div onClick={() => HandleNavigate(item.event_id)} key={index} className="box">
                                <div className="w-[100%] h-[300px] overflow-hidden">
                                    <img src={BaseUrl + item.event_img} className="w-[100%] h-[100%] object-cover hover:scale-[1.1] duration-[0.5s]" alt="" />
                                </div>
                                <div className="px-[15px] py-[20px] bg-white">
                                    <h1>{item.event_title}</h1>
                                    <p className="text-gray-600 text-[14px] mt-[10px] mb-[15px]">{item.event_place_name}</p>
                                    <div className="border-t-[1px]"></div>
                                    <div className="pt-[15px] flex items-center justify-between">
                                        <h1 className="font-bold text-[14px]">{item.event_sdate}</h1>

                                    </div>
                                </div>
                            </div>
                        })
                        : <div className="w-[100%] h-[200px] flex items-center justify-center">
                            <h1 className="font-bold text-gray-600">{t("Event Not Available !!")}</h1>
                        </div>}
                </div>
            </div>
        </div>
    )
}

export default Organizer